import React from 'react';
import { BaseModalProps } from '../../types/modal.types';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSwitcher from '../UI/LanguageSwitcher';

const BaseModal: React.FC<BaseModalProps> = ({
  amount,
  currency = 'TRY',
  badge,
  onClose,
  showCloseButton = true,
  children
}) => {
  const { t } = useLanguage();

  const formatAmount = (value: string | undefined) => {
    if (!value) return '0';
    const num = parseFloat(value);
    return num.toLocaleString('tr-TR', { maximumFractionDigits: 0 });
  };

  const formattedAmount = formatAmount(amount);

  return (
    <div className="base-modal">
      <div className="base-modal__header">
        <div className="base-modal__header-right">
          <LanguageSwitcher />
        </div>
      </div>

      <div className="base-modal__amount-section">
        <div className="base-modal__currency-icon">
          <span>₺</span>
        </div>
        <div className="base-modal__amount">
          <span className="base-modal__amount-value">{formattedAmount}</span>
          <span className="base-modal__amount-currency">{currency}</span>
        </div>
      </div>

      <div className="base-modal__instructions">
        <p>{t('instruction1')}</p>
        <p>{t('instruction2', { amount: formattedAmount })}</p>
        <p>{t('instruction3')}</p>
      </div>

      {children}
    </div>
  );
};

export default BaseModal;
